import React from "react";

import "./styles/global.css";
import { Mensagem, Container } from "./styles/styles";

export default () => {
  return (
    <Container>
      <Mensagem>
        <h1>Ooops...!</h1>
        <p>
          Para acessar o auto-cadastro você precisa do link que foi enviado pela
          sua produtora. Caso tenha clicado nesse link e ainda assim está vendo
          essa mensagem, é possivel que ele esteja incompleto. Qualquer dúvida
          entre em contato com a gente.
        </p>
        <a className="auto" href="https://www.vipprodutora.com.br">
          Enquanto isso, clique aqui e visite nosso site...
        </a>
      </Mensagem>
    </Container>
  );
};
